<template>
  <div class="crm-page">
    <div class="crm-hero">
      <div>
        <div class="crm-eyebrow">客户管理CRM</div>
        <h2>审批中心</h2>
        <p>
          预留延长保护期、归属转移、特殊客户锁定和客户恢复等审批类型，先确认字段和流转操作。
        </p>
      </div>
      <div class="crm-actions">
        <el-tag size="small" type="info">当前审批为前端 mock</el-tag>
      </div>
    </div>

    <el-card shadow="never">
      <el-row :gutter="12">
        <el-col :span="6">
          <el-select
            v-model="filters.type"
            placeholder="申请类型"
            clearable
            style="width: 100%"
          >
            <el-option
              label="延长保护期申请"
              value="延长保护期申请"
            ></el-option>
            <el-option
              label="客户归属转移申请"
              value="客户归属转移申请"
            ></el-option>
            <el-option
              label="特殊客户锁定申请"
              value="特殊客户锁定申请"
            ></el-option>
            <el-option label="客户恢复申请" value="客户恢复申请"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select
            v-model="filters.status"
            placeholder="审批状态"
            clearable
            style="width: 100%"
          >
            <el-option label="待审批" value="待审批"></el-option>
            <el-option label="已通过" value="已通过"></el-option>
            <el-option label="已驳回" value="已驳回"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><el-input
            v-model.trim="filters.keyword"
            placeholder="申请人 / 客户姓名"
            clearable
          ></el-input
        ></el-col>
        <el-col :span="6"
          ><el-button
            style="width: 100%"
            icon="el-icon-refresh-left"
            @click="resetFilters"
            >重置</el-button
          ></el-col
        >
      </el-row>
    </el-card>

    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>审批列表</span>
        <el-tag size="mini" type="warning"
          >{{ filteredApprovals.length }} 条</el-tag
        >
      </div>
      <el-table :data="filteredApprovals" stripe border>
        <el-table-column
          prop="createdAt"
          label="申请时间"
          min-width="140"
        ></el-table-column>
        <el-table-column
          prop="applicant"
          label="申请人"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="customerName"
          label="客户姓名"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="type"
          label="申请类型"
          min-width="150"
        ></el-table-column>
        <el-table-column
          prop="reason"
          label="申请原因"
          min-width="240"
        ></el-table-column>
        <el-table-column prop="status" label="审批状态" width="100">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              :type="
                scope.row.status === '已通过'
                  ? 'success'
                  : scope.row.status === '已驳回'
                  ? 'danger'
                  : 'warning'
              "
              >{{ scope.row.status }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="approver"
          label="审批人"
          min-width="120"
        ></el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <template v-if="scope.row.status === '待审批'">
              <el-button
                type="text"
                @click="handleApproval(scope.row, '已通过')"
                >通过</el-button
              >
              <el-button
                type="text"
                @click="handleApproval(scope.row, '已驳回')"
                >驳回</el-button
              >
            </template>
            <el-button v-else type="text" @click="notifyPending('查看审批详情')"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { createOperationLog, loadCrmState, saveCrmState } from "./mock";

export default {
  name: "CrmApprovals",
  data() {
    return {
      state: loadCrmState(this.$store.getters.GET_TITLE || "当前员工"),
      filters: { type: "", status: "", keyword: "" },
    };
  },
  computed: {
    operatorName() {
      return this.$store.getters.GET_TITLE || "当前员工";
    },
    filteredApprovals() {
      return (this.state.approvals || []).filter((item) => {
        if (this.filters.type && item.type !== this.filters.type) return false;
        if (this.filters.status && item.status !== this.filters.status)
          return false;
        if (this.filters.keyword) {
          const text = `${item.applicant}${item.customerName}`;
          if (text.indexOf(this.filters.keyword) === -1) return false;
        }
        return true;
      });
    },
  },
  methods: {
    notifyPending(label) {
      this.$message.warning(`${label}为预留功能，本阶段先确认审批列表逻辑。`);
    },
    resetFilters() {
      this.filters = { type: "", status: "", keyword: "" };
    },
    handleApproval(row, status) {
      const target = (this.state.approvals || []).find(
        (item) => item.id === row.id
      );
      if (!target) return;
      target.status = status;
      this.state.operationLogs.unshift(
        createOperationLog(
          this.operatorName,
          "审批中心",
          status,
          row.customerName,
          row.type,
          "成功",
          row.reason
        )
      );
      saveCrmState(this.state);
      this.$message.success(`审批已更新为：${status}`);
    },
  },
};
</script>

<style scoped>
.crm-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.crm-hero {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 24px 28px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #e8edf5;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.04);
}
.crm-eyebrow {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(64, 158, 255, 0.12);
  color: #409eff;
  font-size: 12px;
  font-weight: 700;
}
.crm-hero h2 {
  margin: 12px 0 0;
  font-size: 28px;
  color: #111827;
}
.crm-hero p {
  margin: 10px 0 0;
  color: #6b7280;
  line-height: 1.7;
}
.crm-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 1200px) {
  .crm-hero {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
